import { Box } from '@chakra-ui/react';

export const EmptyField = () => (
  <Box
    as="span"
    sx={{
      display: 'inline-block',
      lineHeight: '1',
      color: 'brand.army-green-dark',
      opacity: '30%',
    }}
  >
    -
  </Box>
);
